import { Builder, withChildren } from '@builder.io/react';
import image from '@/assets/images/cms/accordion.svg?inline';

export interface AccordionComponentProps {
	readonly title: string;
	readonly children?: React.ReactNode;
	readonly isDefaultExpanded?: boolean;
	readonly attributes: { readonly [key: string]: string };
}

const register = <TProps extends AccordionComponentProps>(Component: React.FC<TProps>): void => {
	const AccordionWithChildren = withChildren(Component);

	Builder.registerComponent(AccordionWithChildren, {
		name: 'Accordion',
		image,
		inputs: [
			{
				name: 'title',
				type: 'text',
				required: true,
				autoFocus: true,
				bubble: true,
				defaultValue: 'Accordion title...',
			},
			{
				name: 'isDefaultExpanded',
				type: 'boolean',
				defaultValue: false,
				friendlyName: 'Expand by default',
			},
		],
		noWrap: true,
		canHaveChildren: true,

		defaultChildren: [
			{
				'@type': '@builder.io/sdk:Element',
				responsiveStyles: {
					large: {
						padding: 'var(--spacing-md)',
					},
				},
				component: {
					name: 'Text',
					options: {
						text: `
					<p>
						I am some accordion content! You can edit this content or even delete it
						and insert your own instead.
					</p>
					`,
					},
				},
			},
		],
	});
};

export default register;
